// hooks/usePageTracking.ts
"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useEventTracking } from "queries";
import { useAppContext } from "./useAppContext";
import { debounce } from "lodash";
import pathMetaData from "conts/PagesMetaData";

const usePageTracking = () => {
  const pathname = usePathname();

  const pageMetadata = pathMetaData[pathname] || {
    title: "Unknown Page",
    description: "Unknown description",
    imageUrl: "Default image URL",
  };

  const trackPageView = useEventTracking();
  const { profile } = useAppContext();

  const debouncedTrackPageView = debounce(() => {
    trackPageView.mutate({
      event_id: profile?.id as string,
      event_name: "PageView",
      data: { path: pathname },
    });
  }, 1000);

  useEffect(() => {
    debouncedTrackPageView();

    return () => debouncedTrackPageView.cancel();
  }, [pathname]);

  return pageMetadata;
};

export default usePageTracking;
